export function hasCoarsePointer(): boolean {
  return window.matchMedia('(pointer: coarse)').matches;
}
